// extracted by mini-css-extract-plugin
export default {"profile__nav":"interests_profile__nav__mmcnh","savebtn_box":"interests_savebtn_box__7FA0c","updown__icon":"interests_updown__icon__bB5XH","input__box":"interests_input__box__BWS0m"};